import { IActionBase, ISmsSenderIdState } from "../models/root.interface";
import { APPLY_SENDER_ID, DELETE_SMS_IDS } from "../actions/smsSenderId.action";
import { GET_DATA, GET_DATA_BY_ID, GET_SENDER_ID_DETAILS_LOADING } from "../actions/smsSenderId.action";


const initialState: ISmsSenderIdState = {  
    senderIdList: [],
    senderIdData: {},
    senderIdDataById: {},
    smsSenderDeleteIds: [],
    smsSenderDeleteNames: []
};
function smsSenderIdReducer(state: ISmsSenderIdState = initialState, action: IActionBase): ISmsSenderIdState {
    switch (action.type) {
        case APPLY_SENDER_ID: {
            return { ...state, senderIdList: [] };
        }
        case GET_DATA: {
            return { ...state, senderIdData: action.payload };
        }
        case GET_DATA_BY_ID: {
            return { ...state, senderIdDataById: action.payload };
        }
        case GET_SENDER_ID_DETAILS_LOADING: {
            return { ...state, senderIdDataById: {} };
        }
        case DELETE_SMS_IDS:
            return { ...state, smsSenderDeleteIds: action.payload.ids, smsSenderDeleteNames: action.payload.names}  
        default:
            return state;
    }      
}


export default smsSenderIdReducer;